import React, { Component } from 'react';

import SweetAlert from 'sweetalert-react';
import i18n from 'i18n-react';
import { CSSTransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavHashLink as NavLink, HashLink as Link } from 'react-router-hash-link';
import { renderToStaticMarkup } from 'react-dom/server';

import { Account, APIHandler, Burger, BackButton, DataHandler, Diploma, Dropdown, FrameComponent, SideMenu, Search, StorageHandler } from 'C4';
import { directoryUrl, storageKeys, name } from 'settings';


import logo from 'assets/images/logo/logoXpoPRO.png';
// import logo from 'assets/images/logo/logo_white.png';

const resetScrollPosition = () => window.scrollTo(0, 0);

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      firstName: 'Login',
      lastName: '',
      menuToggle: false,
      accountToggle: false,
      lastCheckedMessages: '',
      unreadMessageCount: '',
      frame: '',
      appId: -1,
      diploma: false,
      user: '',
      sweetAlert: false,
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleAccountToggle = this.handleAccountToggle.bind(this);
    this.openSettings = this.openSettings.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        this.setState({
          loggedIn: true,
          firstName: res.response.first_name,
          lastName: res.response.last_name,
          email: res.response.email,
        });
        DataHandler.requestWithId(APIHandler.getUserProgress, res.response.email)
          .then((progress) => {
            const { chapters } = progress.data[0];
            this.setState({ trainingComplete: chapters.every(chapter => chapter.progress >= chapter.total_pages) });
          });
      } else {
        this.setState({ loggedIn: res });
      }
    });
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(APIHandler.getUnreadMessages, this.state.lastCheckedMessages)
      .then((res) => {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      });
  }

  handleMenuToggle() {
    const container = document.getElementById('container');
    this.setState(prevState => ({
      menuToggle: !prevState.menuToggle,
    }));
    container.classList.remove('offsetContainer');
    window.scrollTo(0, 0);
  }

  handleAccountToggle() {
    this.setState(prevState => ({
      accountToggle: !prevState.accountToggle,
    }));
    this.checkForUnreadMessages();
  }

  handleClickOutside() {
    const container = document.getElementById('container');
    this.setState({ menuToggle: false, accountToggle: false });
    container.classList.remove('offsetContainer');
  }

  openSettings() {
    const { appId, user } = this.state;
    if (appId === -1 || user === '') {
      DataHandler.matchAppId().then((id) => {
        StorageHandler.load(storageKeys.user).then((userKey) => {
          const { email } = userKey.response;
          this.setState({
            appId: id,
            user: email,
            frame: `https://crm.channelpromobile.com/profile/?email=${email}&app_id=${id}`,
            sweetAlert: true,
          });
        });
      });
    } else {
      this.setState({ frame: `https://crm.channelpromobile.com/profile/?email=${user}&app_id=${appId}`, sweetAlert: true });
    }
  }

  frame(src) {
    this.setState({ diploma: src });
  }

  closeSettings() {
    this.setState({ sweetAlert: false });
  }

  render() {
    const {
      accountToggle,
      diploma,
      email,
      firstName,
      frame,
      lastName,
      loggedIn,
      menuToggle,
      sweetAlert,
      trainingComplete,
      unreadMessageCount,
    } = this.state;
    const { pathname } = this.props;
    return (
      <div>
        <SweetAlert
          title=""
          show={sweetAlert}
          html
          customClass="companionSweetAlert"
          text={renderToStaticMarkup(<FrameComponent
            src={frame}
          />)}
          showCancelButton
          confirmButtonText={i18n.translate('general.close')}
          onConfirm={() => this.closeSettings()}
          onCancel={() => this.closeSettings()}
          onOutsideClick={() => this.closeSettings()}
          onEscapeKey={() => this.closeSettings()}
        />
        <nav className={pathname === '/main' || pathname === '/' || pathname === '' ? 'home' : 'mini'}>
          <ul className="secondaryNav">
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink onClick={resetScrollPosition} className="xp" activeClassName="is-active" to="/main/prize-center">800<span>XP</span></NavLink>
            </li>
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink onClick={resetScrollPosition} className="fav" activeClassName="is-active" to="/main/favorites"><FontAwesomeIcon icon={['far', 'heart']} /></NavLink>
            </li>
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink onClick={resetScrollPosition} className="search" activeClassName="is-active" to="/main/search"><FontAwesomeIcon icon={['far', 'search']} /></NavLink>
            </li>
            <li className={loggedIn ? '' : 'disabled'}>
              <NavLink onClick={resetScrollPosition} activeClassName="is-active" to="/main/messages"><FontAwesomeIcon icon={['far', 'envelope']} /></NavLink>
            </li>
            <li className={loggedIn ? ' ' : 'navLogin'}>
              {loggedIn ?
                <Account
                  onClick={this.handleAccountToggle}
                  firstName={firstName}
                  expanded={accountToggle}
                />
                :
                <NavLink exact to="/login">
                  <button className="account">
                    <FontAwesomeIcon icon={['fas', 'user']} />
                    {firstName}
                  </button>
                </NavLink>}
            </li>
          </ul>
        </nav>
        <CSSTransitionGroup
          transitionName="accountToggle"
          transitionEnterTimeout={150}
          transitionLeaveTimeout={150}
        >
          {accountToggle &&
            <Dropdown
              handleClickOutside={this.handleClickOutside}
              outsideClickIgnoreClass="account"
              firstName={firstName}
              lastName={lastName}
              email={email}
              unreadMessageCount={unreadMessageCount}
              openSettings={this.openSettings}
              trainingComplete={trainingComplete}
              diploma={src => this.frame(src)}
            />}
        </CSSTransitionGroup>
        <CSSTransitionGroup
          transitionName="menuToggle"
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}
        >
          {menuToggle &&
          <SideMenu
            handleClickOutside={this.handleClickOutside}
            outsideClickIgnoreClass="burgerMenu"
            firstName={firstName}
            lastName={lastName}
            email={email}
          />}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default Nav;
